/* TODO DIGITAL — global.js */
(function () {
  'use strict';

  /* ----- Menú móvil ----- */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* ----- Cuentas regresivas (unificadas) -----
     Todos los .td-countdown de la página comparten el MISMO deadline:
     se calcula una sola vez por clave (data-key) y se reutiliza, así la
     barra de anuncios, el banner de oferta y la ficha de producto
     muestran siempre exactamente el mismo tiempo restante.
       - data-deadline="2026-12-31 23:59" -> fecha fija (igual para todos)
       - data-evergreen-hours="24"        -> contador por visitante
     Se configura en Configuración del tema > Cuenta regresiva.          */
  function pad(n) { return String(n).padStart(2, '0'); }

  var deadlines = {};

  function keyOf(el) {
    return 'td_countdown_' + (el.getAttribute('data-key') || 'global');
  }

  function fixedDeadline(el) {
    var fixed = el.getAttribute('data-deadline');
    if (!fixed) return null;
    var d = new Date(fixed.trim().replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  function resolveDeadline(el, restart) {
    var fixed = fixedDeadline(el);
    if (fixed !== null) return fixed;

    var key = keyOf(el);
    if (!restart && deadlines[key]) return deadlines[key];

    var hours = parseFloat(el.getAttribute('data-evergreen-hours'));
    if (!hours || isNaN(hours) || hours <= 0) hours = 24;

    var now = Date.now();
    var stored = null;
    try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) {}

    var deadline;
    if (!restart && stored && stored > now) {
      deadline = stored;
    } else {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(deadline)); } catch (e) {}
    }
    deadlines[key] = deadline;
    return deadline;
  }

  var countdowns = Array.prototype.slice.call(document.querySelectorAll('.td-countdown'));

  function paint(el) {
    var diff = resolveDeadline(el, false) - Date.now();
    if (diff < 0) diff = 0;

    var total = Math.floor(diff / 1000);
    var days = Math.floor(total / 86400);
    var hrs = Math.floor((total % 86400) / 3600);
    var mins = Math.floor((total % 3600) / 60);
    var secs = total % 60;

    var elDays = el.querySelector('[data-days]');
    if (elDays) {
      elDays.textContent = pad(days);
    } else {
      hrs = hrs + days * 24;
    }

    var elHours = el.querySelector('[data-hours]');
    var elMins = el.querySelector('[data-minutes]');
    var elSecs = el.querySelector('[data-seconds]');
    if (elHours) elHours.textContent = pad(hrs);
    if (elMins) elMins.textContent = pad(mins);
    if (elSecs) elSecs.textContent = pad(secs);
  }

  function tick() {
    var now = Date.now();
    /* Primero reiniciamos en bloque los contadores evergreen vencidos,
       para que todos vuelvan a arrancar con el mismo deadline. */
    countdowns.forEach(function (el) {
      if (fixedDeadline(el) !== null) return;
      var key = keyOf(el);
      if (deadlines[key] && deadlines[key] - now <= 0) resolveDeadline(el, true);
    });
    countdowns.forEach(paint);
  }

  if (countdowns.length) {
    countdowns.forEach(function (el) { resolveDeadline(el, false); });
    tick();
    setInterval(tick, 1000);
  }

  /* ----- Galería de producto: cambiar imagen principal ----- */
  var mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-full') || thumb.src;
      mainImg.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
})();
